@if (isInitialized) {
    <div class="ws-flex-container-vertical ws-flex-auto">
        <ws-bread-crumbs [breadcrumbs]="breadcrumbs" currentPageTitle="Chart of Accounts"></ws-bread-crumbs>
        <div class="ws-section">
            <div class="ws-section__header">
                <h4 class="ws-section__header__title">
                    Chart of Accounts
                    <ag-grid-row-count [gridApi]="gridApi"
                                       [gridTracker]="gridTracker"
                                       [gridOptions]="gridOptions"></ag-grid-row-count>
                </h4>
                <div class="ws-section__header__actions">
                    @if (canEdit) {
                        <div class="ws-section__header__actions__item">
                            <button type="button" class="ace-btn btn-sm btn-primary"
                                    (click)="add()"
                                    helpTooltip
                                    helpContentId="gl-account-list.new-gl-account"
                                    position="bottom">New G/L Account
                            </button>
                        </div>
                    }
                    <div class="ws-section__header__actions__item">
                        <button type="button"
                                class="ace-btn btn-sm btn-secondary has-icon"
                                (click)="refresh()"
                                [disabled]="refreshing"
                                helpTooltip
                                helpContentId="app.refresh"
                                position="bottom"><i class="fa fa-refresh"></i></button>
                    </div>
                </div>
            </div>
        </div>
        <ws-ag-grid-angular [gridOptions]="gridOptions"
                            (gridReady)="onAgGridReady($event)"
                            [companyId]="companyId"
                            [exportOptions]="exportOptions"
                            [gridId]="gridId"
                            [isBulkUpdateVisible$]="isBulkUpdateVisible$"
                            (bulkUpdate)="bulkUpdate()">
        </ws-ag-grid-angular>
    </div>
}
